import { Text } from '../../../../shared-components';
import { Masonry } from '../../../../shared-components/masonry/Masonry';
import { SimpleFieldValue } from './SimpleFieldValue';

const programs = {
  telemedicine: 'Telemedicine',
  wellness_differential: 'Wellness Differential',
  disease_management_program: 'Disease Management',
  specialty_pharmacy_program: 'Specialty Pharmacy',
  health_reimbursement_arrangement: 'Health Reimbursement Arrangement',
  health_savings_account: 'Health Savings Account',
  flexible_spending_account: 'Flexible Spending Account',
  custom: 'Custom',
};

export const programList = Object.entries(programs);

export const CustomDetails = ({ customDetailsList }) => {
  return (
    <Masonry.Group>
      <Masonry.Group.Title value="Additional Details" />
      <Masonry.Group.Content>
        {customDetailsList.map(({ Title, Description }, idx) => (
          <Masonry.Group.Item key={Title + idx}>
            <Text label>{Title}</Text>
            <SimpleFieldValue field={{ Type: 'text-input', value: Description }} />
          </Masonry.Group.Item>
        ))}
      </Masonry.Group.Content>
    </Masonry.Group>
  );
};
